import React, { useEffect, useState } from 'react';
import { Settings, Trash2, Link, Info } from 'lucide-react'; // Import Link icon
import '../shared/AccordianStyle.css';
import { motion, AnimatePresence } from 'framer-motion';
import { CCol, CFormCheck, CFormInput, CFormTextarea, CRow, CTooltip, CButton, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CFormSelect, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react';
import PlanInfoModel from './PlanInfoModel';

const GenricAccordian = ({ title, content, setParentAccordions, parentId, information, handleAddStatementDescription, index, setActiveDescriptions }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [infoModelVisible, setInfoModelVisible] = useState(false)



    const toggleAccordion = () => {
        setIsOpen(!isOpen);

    };

    return (
        <div className="accordion-item w-full accordion-scope mt-2 border generic-accordion-theme" style={{ borderRadius: '10px', border: `${isOpen ? 'border' : 'none'}` }}  >
            <button
                className={`accordion-button ${!isOpen ? 'collapsed' : ''} d-flex justify-content-between align-items-center generic-accordion-theme__trigger`}
                type="button"
                onClick={toggleAccordion}
                style={{
                    borderRadius: '10px',
                    padding: '15px 20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'outline 0.3s ease, box-shadow 0.3s ease',
                    fontWeight: '600',
                    fontSize: '1rem',
                }}
            >
                {title.name || title}

                <div>
                    <span className="custom-icon ms-auto d-flex gap-1">

                        <Info
                            className="generic-accordion-theme__icon"
                            size={20}
                            strokeWidth={1.5}
                            onClick={() => {
                                setActiveDescriptions("statement")
                                handleAddStatementDescription({
                                    parentId,
                                    orderIndex: index,
                                    name: title.name || title,
                                },
                                    title?.description ?? ""
                                )
                            }}
                        />

                    </span>
                </div>
            </button>
            {
                // <PlanInfoModel infoModelVisible={infoModelVisible} setInfoModelVisible={setInfoModelVisible} title={title} setParentAccordions={setParentAccordions} parentId={parentId} information={information} />
            }
            {/* <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        className="accordion-collapse"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                    >
                        <div className="accordion-body">
                            {content}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence> */}
        </div>
    );
};

export default GenricAccordian;
